import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '@terminal/routes/query-params';
import {
  POSTHOG_TRACKING_SOURCES,
  PosthogTrackingSource,
} from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';

interface UseGeographicDrawerOptions {
  entityTag?: string;
  source?: PosthogTrackingSource;
}

export const useGeographicDrawer = ({
  entityTag,
  source,
}: UseGeographicDrawerOptions = {}) => {
  const { deleteQueryParam, setQueryParams, params } = useQueryParams();
  const { trackKgGeographyDrawerOpen } = usePosthogEvents();

  const isDrawerOpen =
    params[queryKeys.activeDrawer] === queryValues.geographicExposureDrawer;
  const countryCode = params[queryKeys.countryCode];
  const regionName = params[queryKeys.regionName];

  const resolvedSource = source ?? POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW;
  const entities = entityTag ? [entityTag] : [];

  const openCountry = (code: string) => {
    trackKgGeographyDrawerOpen(resolvedSource, 'country', entities);
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.geographicExposureDrawer,
      [queryKeys.countryCode]: code,
      [queryKeys.regionName]: '',
    });
  };

  const openRegion = (name: string) => {
    trackKgGeographyDrawerOpen(resolvedSource, 'region', entities);
    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.geographicExposureDrawer,
      [queryKeys.regionName]: name,
      [queryKeys.countryCode]: '',
    });
  };

  const closeDrawer = () =>
    deleteQueryParam([
      queryKeys.activeDrawer,
      queryKeys.countryCode,
      queryKeys.regionName,
    ]);

  const type = regionName ? 'region' : countryCode ? 'country' : null;

  return {
    closeDrawer,
    openCountry,
    openRegion,
    isDrawerOpen,
    countryCode,
    regionName,
    type,
  };
};
